import { Component } from 'react'
import { func, shape } from 'prop-types'
import { withRouter } from 'react-router'

class OnLocationChangeComponent extends Component {
  componentDidMount () {
    this.props.history.listen(this.props.onChange)
  }

  render () {
    return null
  }
}

OnLocationChangeComponent.propTypes = {
  onChange: func,
  history: shape({
    listen: func
  })
}

export const OnLocationChange = withRouter(OnLocationChangeComponent)



// WEBPACK FOOTER //
// ./src/components/router/OnLocationChange.js